var _defs, _style, _g, _g2, _defs2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcessedSvgIllusUsagePolicies1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_160c8fa9dec5d0",
    x: "0px",
    y: "0px",
    viewBox: "0 0 314.2 299",
    style: {
      enableBackground: "new 0 0 314.2 299"
    },
    xmlSpace: "preserve",
    "aria-hidden": "true",
    width: "314px",
    height: "299px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    className: "cerosgradient",
    id: "CerosGradient_iddead70b4c",
    gradientUnits: "userSpaceOnUse",
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("linearGradient", null))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0-60c8fa9dec5d0{fill:#68737A;}\r\n\t.st1-60c8fa9dec5d0{fill:#E5F4FA;}\r\n\t.st2-60c8fa9dec5d0{display:none;}\r\n\t.st3-60c8fa9dec5d0{display:inline;fill:none;stroke:#E5F4FA;stroke-width:10;}\r\n\t.st4-60c8fa9dec5d0{display:inline;fill:#68737A;}\r\n\t.st5-60c8fa9dec5d0{display:inline;}\r\n\t.st6-60c8fa9dec5d0{clip-path:url(#SVGID_2_60c8fa9dec5d0);}\r\n\t.st7-60c8fa9dec5d0{fill:#6AE692;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_17260c8fa9dec5d0",
    transform: "translate(-62.08 -12.972)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16660c8fa9dec5d0",
    transform: "translate(263.823 12.972)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14060c8fa9dec5d0",
    x: -199,
    className: "st0-60c8fa9dec5d0",
    width: 251.6,
    height: 297.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35360c8fa9dec5d0",
    className: "st1-60c8fa9dec5d0",
    d: "M26.7,202.7l-44.8-34.5l14.9-19.3l25.4,19.5l70.9-92.9l19.4,14.8L26.7,202.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16560c8fa9dec5d0",
    transform: "translate(35.09 88.373)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14160c8fa9dec5d0",
    x: -199,
    y: 0,
    className: "st1-60c8fa9dec5d0",
    width: 88.5,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14260c8fa9dec5d0",
    x: -199,
    y: 42.9,
    className: "st1-60c8fa9dec5d0",
    width: 88.5,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14360c8fa9dec5d0",
    x: -199,
    y: 85.8,
    className: "st1-60c8fa9dec5d0",
    width: 88.5,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14460c8fa9dec5d0",
    x: -199,
    y: 128.7,
    className: "st1-60c8fa9dec5d0",
    width: 88.5,
    height: 12
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16760c8fa9dec5d0",
    transform: "translate(62.08 158.769)",
    className: "st2-60c8fa9dec5d0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36260c8fa9dec5d0",
    className: "st3-60c8fa9dec5d0",
    d: "M-111.3,237.4l26.5-32.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35460c8fa9dec5d0",
    className: "st4-60c8fa9dec5d0",
    d: "M-52.2,224.6c-61.4-12.2-101.4-71.8-89.2-133.2S-69.6-10-8.2,2.2S93.2,74,81,135.4c0,0,0,0,0,0    C68.8,196.8,9.2,236.7-52.2,224.6z M-11.8,20.2C-63.2,10-113.2,43.5-123.4,95s23.3,101.4,74.7,111.6    C2.8,216.7,52.8,183.3,63,131.8c0,0,0,0,0,0C73.1,80.4,39.7,30.5-11.8,20.2L-11.8,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35560c8fa9dec5d0",
    className: "st4-60c8fa9dec5d0",
    d: "M-118,222.6l22.6,16.9l-77.5,105.6l-26.1-18.6L-118,222.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17160c8fa9dec5d0",
    transform: "translate(134.41 176.335)",
    className: "st2-60c8fa9dec5d0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5-60c8fa9dec5d0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_60c8fa9dec5d0",
    cx: -102.9,
    cy: 96.1,
    r: 96.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_60c8fa9dec5d0"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_60c8fa9dec5d0",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17060c8fa9dec5d0",
    className: "st6-60c8fa9dec5d0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16960c8fa9dec5d0",
    transform: "translate(84.925 -201.811)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14560c8fa9dec5d0",
    x: -199,
    y: 0,
    className: "st0-60c8fa9dec5d0",
    width: 323.8,
    height: 382.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35660c8fa9dec5d0",
    className: "st7-60c8fa9dec5d0",
    d: "M91.5,260.8l-57.7-44.4L53,191.6l32.7,25.2l91.2-119.6l24.9,19L91.5,260.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16860c8fa9dec5d0",
    transform: "translate(45.161 113.734)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14660c8fa9dec5d0",
    x: -199,
    y: 0,
    className: "st1-60c8fa9dec5d0",
    width: 113.9,
    height: 15.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14760c8fa9dec5d0",
    x: -199,
    y: 55.2,
    className: "st1-60c8fa9dec5d0",
    width: 113.9,
    height: 15.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14860c8fa9dec5d0",
    x: -199,
    y: 110.4,
    className: "st1-60c8fa9dec5d0",
    width: 113.9,
    height: 15.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14960c8fa9dec5d0",
    x: -199,
    y: 165.6,
    className: "st1-60c8fa9dec5d0",
    width: 113.9,
    height: 15.4
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessedSvgIllusUsagePolicies1);
export default __webpack_public_path__ + "static/media/processed-svg-illus-usage-policies1.42a3a59d362f6af365c2b55209f07ad5.svg";
export { ForwardRef as ReactComponent };